import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Subscription } from '../Api/Subscription';
import { Toast } from '../hooks/useToast';


export const fetchSubscriptionThunk = createAsyncThunk(
    'subscription/fetch',
    async (_, { getState }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await Subscription.fetch({ api_token });
            return response.data
        } catch (err) {
            return Promise.reject(err);
        }
    }
)


const initialState = {
    status: "pending",
    data: [],
}

export const subscriptionSlice = createSlice({
    name: 'subscriptions',
    initialState,
    reducers: {
        setStatus: (state, actions) => {
            return {
                ...state,
                ...actions.payload
            }
        },
        resetState: () => {
            return initialState
        },
    },
    extraReducers: {
        [fetchSubscriptionThunk.fulfilled]: (state, action) => {
            state.data = action.payload
            state.status = "success"
        },
        [fetchSubscriptionThunk.pending]: (state, action) => {
            state.status = "loading"
        },
        [fetchSubscriptionThunk.rejected]: (state, action) => {
            state.status = "error"
        },
    }
})


// Action creators are generated for each case reducer function
export const { setStatus,resetState } = subscriptionSlice.actions

export default subscriptionSlice.reducer